import { parseDate } from './utils'

export default class MedicalExpertiseDisability {
	static fromJSON(json) {
		return new MedicalExpertiseDisability(json.expertise).withDisabilities(
			json.disabilities
		)
	}

	constructor(expertise) {
		this.expertise = expertise
	}

	withDisabilities(json) {
		this.disabilities = (json ?? []).map((disability) => ({
			daysCount: disability.daysCount,
			rate: disability.disabilityRate,
			name: disability.disability,
			startDate: parseDate(disability.startDate),
			endDate: parseDate(disability.endDate),
		}))

		return this
	}
}
